module.exports = __webpack_public_path__ + "img/wallpaper-9.b4e48d9a.png";